import DeliveryNoteIcon from 'assets/dialogue-avatar-delivery-note.svg';
import { DialogueCardData, DialogueType } from 'models/DialogCard';
import { ArticleAddress, ArticleEvent, RedirectStatus } from 'models/shipments';

import { formatAddress } from '../../../../utils/string.utils';
import AddressDisplay from '../../common/AddressDisplay/AddressDisplay';

export function getRedirectCard(
  redirectStatus: RedirectStatus | null,
  latestEvent?: ArticleEvent | null,
  redirectAddress?: ArticleAddress | null
): DialogueCardData | null {
  if (redirectStatus === RedirectStatus.REDIRECT_REQUESTED) {
    const addressLines = redirectAddress ? formatAddress(redirectAddress) : [];
    return {
      analyticsId: 'redirectRequested',
      icon: <DeliveryNoteIcon />,
      type: DialogueType.DELIVERY_NOTE,
      title: `You’ve requested to redirect your parcel`,
      content: (
        <>
          <AddressDisplay addressLines={addressLines} />
          <p>If we can redirect it, we’ll update the delivery address and date here.</p>
        </>
      ),
    };
  }
  const latestEventCode = latestEvent?.eventCode;
  const isTransferredEventCode = latestEventCode === 'ZPT_CREATE_LB';
  if (isTransferredEventCode) {
    return {
      analyticsId: 'redirectActioned',
      icon: <DeliveryNoteIcon />,
      type: DialogueType.DELIVERY_NOTE,
      title: `We’ve redirected it`,
      content: <p>The new delivery address is shown below.</p>,
    };
  }
  return null;
}
